import { HashRouter } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { AuthProvider } from '@/store/AuthContext';
import { AppRoutes } from '@/routes/AppRoutes';
import { queryClient } from '@/queryClient';
import { TaskRealtimeBridge } from '@/features/tasks/components/TaskRealtimeBridge';

const theme = {
  token: {
    colorPrimary: '#F5B800',
    borderRadius: 10,
    fontFamily: "Calibri, 'Open Sans', sans-serif",
    fontSize: 14,
    fontSizeSM: 13,
    fontSizeLG: 16,
    colorText: '#1A1A1A',
    colorTextSecondary: '#6B7280',
  },
  components: {
    Button: {
      primaryShadow: 'none',
    },
    Table: {
      stickyScrollBarBg: '#c3e2fa',
    },
  },
};

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={theme}>
          <AntApp>
            <AuthProvider>
              <TaskRealtimeBridge />
              <HashRouter>
                <AppRoutes />
              </HashRouter>
            </AuthProvider>
          </AntApp>
        </ConfigProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
